export default "__VITE_ASSET__0ca9c825__"